import {
  Component,
  EventEmitter,
  Output,
  ChangeDetectionStrategy,
  OnInit,
  Input,
  OnDestroy,
  ChangeDetectorRef,
} from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';

import { LocalDate, unsubscribe } from '@fcom/core/utils';
import { DestinationSearchTripDates } from '@fcom/destination-search/interfaces';
import { DateRange } from '@fcom/ui-components';

const DAYS_AMOUNT = 360; // Default calendar size

@Component({
  selector: 'fin-destination-search-date-field',
  templateUrl: 'destination-search-date-field.component.html',
  styleUrls: ['destination-search-date-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DestinationSearchDateFieldComponent implements OnInit, OnDestroy {
  @Input() selectedDates$: Observable<DestinationSearchTripDates>;

  @Input() showReturnField$: Observable<boolean>;

  /**
   * Emits selected dates
   */
  @Output() dateChange = new EventEmitter<DestinationSearchTripDates>();

  datepickerOpen = false;
  selectableDatesRange: DateRange;
  calendarDates$ = new BehaviorSubject<DestinationSearchTripDates>(undefined);

  private currentDate: LocalDate = LocalDate.now();
  private subscription = new Subscription();

  readonly SvgLibraryIcon = SvgLibraryIcon;

  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    // TODO: check if earliest day can now be today instead of tomorrow
    this.selectableDatesRange = [this.currentDate.plusDays(1), this.currentDate.plusDays(DAYS_AMOUNT)];
    this.subscription.add(
      this.selectedDates$.subscribe((tripDates: DestinationSearchTripDates) => {
        this.calendarDates$.next(tripDates);
        this.cd.detectChanges();
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription = unsubscribe(this.subscription);
  }

  openDatepicker(): void {
    this.datepickerOpen = true;
  }

  closeDatepicker(): void {
    this.datepickerOpen = false;
  }

  updateTravelDates(calendarDates: DestinationSearchTripDates): void {
    this.dateChange.emit(calendarDates);
  }

  updateCalendarDates([departureDate, returnDate]:
    | [string | undefined, string | undefined]
    | [string | undefined]): void {
    this.calendarDates$.next({
      departureDate: departureDate ? new LocalDate(departureDate) : undefined,
      returnDate: returnDate ? new LocalDate(returnDate) : undefined,
    });
  }
}
